import React from 'react';
import { XylexaLoginPage } from './XylexaLoginPage';
import { AuthenticationContextProvider } from '@xylexa/xylexa-app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const XylexaApp = props => {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        checkLoginIframe: false,
      }}
    >
      <AuthenticationContextProvider onUnauthenticated={() => keycloak.login()}>
        <QueryClientProvider client={queryClient}>
          <XylexaLoginPage
            defaultExtensions={props.defaultExtensions}
            defaultModes={props.defaultModes}
          />
          <ToastContainer />
        </QueryClientProvider>
      </AuthenticationContextProvider>
    </ReactKeycloakProvider>
  );
};
